/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FoodDrinkMilkIcon20Solid = forwardRef('FoodDrinkMilkIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M3 17V8.719c0-.434.206-.767.443-1.109L5.47 5.293 8 8.667V19H5a2 2 0 0 1-2-2Z" }),
        React.createElement("path", { d: "M9 19h6a2 2 0 0 0 2-2V9H9v10Z" }),
        React.createElement("path", { d: "M16.817 8 14.75 5H6.5l2.25 3h8.067Z" }),
        React.createElement("path", { d: "M14.75 4V2.25a1 1 0 0 0-1-1h-7.5a1 1 0 0 0-1 1V4h9.5Z" })));
});
